<div class="wrapper">

  <mat-progress-spinner diameter="50" mode="indeterminate" color="primary"></mat-progress-spinner>

  <span>{{ loaderMessage }}</span>

</div>

